document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.together-block__slider');

  if (slider) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(entry => {
        // When the slider is within 100px of the screen
        if (entry.isIntersecting && entry.intersectionRatio > 0) {
          const sliderInstance = new Splide(slider, {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            perPage: 1,
            arrows: false,
            pagination: false,
            autoScroll: {
              speed: 0.9,
            },
          }).mount(window.splide.Extensions);

          // Stop the observer after the slider has been initialized
          observer.disconnect();
        }
      });
    }, {
      rootMargin: '100px',
    });

// Start watching the slider
    observer.observe(slider);
  }
});
